export default __webpack_public_path__ + "static/media/myimage2.3f356b70.jpeg";